import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, Injectable } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';

import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';

import * as Raven from 'raven-js';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {AngularFireModule} from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AuthenticationService } from './services/authentication.service';
import { AnalyticsService } from './services/analytics.service';
import { UpdateNotificationComponent } from './shared/update-notification/update-notification.component';
import { BrochureRedirectComponent } from './shared/brochure-redirect/brochure-redirect.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';

import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { provideFirestore, initializeFirestore } from '@angular/fire/firestore';
import { provideFunctions, getFunctions } from '@angular/fire/functions';

Raven
.config('https://8e4c3c458a164945823d048f50013f62@sentry.io/222554')
.install();

@Injectable()
export class RavenErrorHandler implements ErrorHandler {
  handleError(err: any): void {
    Raven.captureException(err);
  }
}

@NgModule({
  declarations: [
    AppComponent,
    UpdateNotificationComponent,
    BrochureRedirectComponent,
    NotFoundComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    HttpClientModule,

    /**
     * Compat initializer — required for:
     *  - AngularFireAuthModule (compat)
     *  - Any other compat services
     */
    AngularFireModule.initializeApp(environment.firebase),

    /**
     * Modular initializer — required for:
     *  - Modular Firestore
     *  - Modular Functions
     */
    provideFirebaseApp(() => initializeApp(environment.firebase)),

    /**
     * Firestore using your custom databaseId
     */
    provideFirestore(() => {
      const app = getApp(); // IMPORTANT: do NOT call initializeApp again
      return initializeFirestore(app, {}, 'au-region');
    }),

    /**
     * Cloud Functions with region
     */
    provideFunctions(() =>
      getFunctions(undefined, 'australia-southeast1')
    ),

    /**
     * Auth via COMPAT API
     */
    AngularFireAuthModule,

    AppRoutingModule,
  ],
  providers: [
    AuthenticationService,
    AnalyticsService,
    { provide: ErrorHandler, useClass: RavenErrorHandler },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
